import { IPromise } from 'angular';

export class SocialLoginService {
    static $inject = ['$http'];

    SOCIAL_LOGIN_URL = '/social/permission-grants/request?app_scope=livestreaming';
    windowFeatures = 'width=600,height=500,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes';

    constructor(private $http: ng.IHttpService) {}

    signIn() {
        return new Promise((resolve, reject) => {
            const socialLoginWindow = window.open(this.SOCIAL_LOGIN_URL, 'socialLogin', this.windowFeatures);
            let windowClosedCheckInterval: any;

            const fail = (error: string) => {
                windowClosedCheckInterval && clearInterval(windowClosedCheckInterval);
                reject(error);
            };

            const success = (accessToken: string) => {
                windowClosedCheckInterval && clearInterval(windowClosedCheckInterval);
                resolve(accessToken);
            };

            if (!socialLoginWindow) {
                return;
            }

            windowClosedCheckInterval = setInterval(() => socialLoginWindow.closed && fail('window closed'), 100);

            window.addEventListener('message', (event) => {
                if (event?.data?.type === 'social-login-error') {
                    return fail('social-login-error');
                }

                if (event?.data?.type === 'social-login-success') {
                    clearInterval(windowClosedCheckInterval);
                    socialLoginWindow.close();
                    this.getAccessToken()
                        .then((token: string) => {
                            if (token) {
                                return success(token);
                            }

                            fail('no access token');
                        })
                        .catch((e) => fail(e));
                    return;
                }
            });
        });
    }

    getAccessToken(): IPromise<string> {
        return this.$http
            .get('/api/v1.0/social/permission-grants/access-token?app_scope=livestreaming')
            .then((response: any) => response?.data?.data?.access_token);
    }
}

angular.module('tradersyard').service('SocialLoginService', SocialLoginService);
